import React from 'react'
import { Text } from '@lightspeed/design-system-react'
import { vn, add } from 'vend-number'

import { RoundedNumber } from '../../CashPaymentModal'
import { useVdCurrencyFilter } from '../../../../../ng-compat/hooks'

interface HeaderProps {
  amountToPay: RoundedNumber
}

// Component
export const Header: React.FC<HeaderProps> = ({ amountToPay }) => {
  const roundedAmountToPay = vn(amountToPay.rounded)
  const originalAmountToPay = add(amountToPay.remainder, roundedAmountToPay)

  const vdCurrencyFilter = useVdCurrencyFilter()

  return (
    <div className="payment-cash-modal-header">
      <div className="payment-cash-modal-header-headline">Amount to pay</div>
      <div className="payment-cash-modal-header-balance">
        {vdCurrencyFilter(roundedAmountToPay.toNumber())}
        <Text tag="p">
          {!roundedAmountToPay.eq(originalAmountToPay) &&
            `Rounded ${
              roundedAmountToPay.gt(originalAmountToPay) ? 'up' : 'down'
            } from ${vdCurrencyFilter(originalAmountToPay)}`}
        </Text>
      </div>
    </div>
  )
}
